// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueSweetalert2 from 'vue-sweetalert2';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import router from './router';
import store, { init } from './store';

import 'normalize.css/normalize.css';

import Footer from './components/Footer.vue';
import 'swiper/css/swiper.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import './css/main.css';
import './css/theme.css';

// eslint-disable-next-line no-unused-vars
function getQueryStringParameterByName(name, url) {
  // eslint-disable-next-line no-param-reassign
  if (!url) url = window.location.href;
  // eslint-disable-next-line no-param-reassign, no-useless-escape
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

Vue.config.productionTip = false;
Vue.use(VueSweetalert2);
Vue.use(VueAwesomeSwiper);
Vue.use(VueI18n);
Vue.use(require('vue-cookies'));

Vue.component('Footer', Footer);
Vue.prototype.$store = store;

Vue.prototype.$statPage = function statPage(params) {
  if (!window.gtag) {
    setTimeout(() => {
      statPage(params);
    }, 1000);
    return;
  }
  try {
    // eslint-disable-next-line no-underscore-dangle
    window.gtag('config', window._gId, params);
  } catch (err) {
    console.error(err);
  }
};

Vue.prototype.$statEvent = function statEvent(eventName) {
  if (!window.gtag) {
    setTimeout(() => {
      statEvent(eventName);
    }, 1000);
    return;
  }

  try {
    // eslint-disable-next-line no-underscore-dangle
    window.gtag('event', eventName);
  } catch (err) {
    console.error(err);
  }
};

init();

const messages = require('./i18n');

const navigatorLocale = (navigator.language || navigator.userLanguage).slice(0, 2).toLowerCase();
const lgQuery = (getQueryStringParameterByName('lg') || '').trim();
const defaultLocale = lgQuery.length > 0 ? lgQuery : navigatorLocale;

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: defaultLocale, // set locale
  fallbackLocale: messages.fallbackLocale,
  messages, // set locale messages
});

document.title = messages.websiteTitle;

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

const warningDescCSS = 'font-size: 16px;';
console.log('');
console.log('');
console.log('%cHi there!', warningDescCSS);
console.log(
  "%cLooking for something?, don't hesitate to contact us info@priintr.com or visit https://www.priintr.com for more information.",
  warningDescCSS,
);
console.log('%cHave a nice day.', warningDescCSS);
console.log('');
console.log('');
